import { Link } from 'react-router-dom';
const SightSeeingTabs = (props) => {
    return (
            <ul className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3" role="tablist">
                <li className="nav-item" role="presentation">
                    <Link to={"/sightseeing/search"} className={props.pageName === "SEARCH" ? "nav-link active bg-primary text-white" : "nav-link"}>SEARCH</Link>
                </li>
                <li className="nav-item" role="presentation">
                    <Link to={"/sightseeing/bookings"} className={props.pageName === "SIGHTSEEINGBOOKING" ? "nav-link active bg-primary text-white" : "nav-link"}>BOOKINGS</Link>
                </li>
                {/* <li className="nav-item" role="presentation">
                    <Link to={"/hotel/bookings"} className={props.pageName === "PENDINGBOOKING" ? "nav-link active bg-primary text-white" : "nav-link"}>PENDING BOOKINGS</Link>
                </li>
                <li className="nav-item" role="presentation">
                    <Link to={"/hotel/cancelledbookings"} className={props.pageName === "CANCELLEDBOOKING" ? "nav-link active bg-primary text-white" : "nav-link"}>CANCELLED BOOKINGS</Link>
                </li> */}
            </ul>
    );
};

export default SightSeeingTabs;